// VER 2025 May 13
import API, { ApiReady, G_apiBaseUrl } from 'service/api'
import DataUtil from 'service/data-util'
import {
  getPrimaryContact,
  tryParsePhoneNumber,
  adjustMessageData
} from 'service/extension/messaging'

import PopMessage from 'component/pop-msg/PopMessage'

import { processCommand } from 'service/wscommand/WsCommandExecutor'

//-----------------------------------------------------------------------------
// Base objects | lazy init
let _setRefresher = null
let _subscriber   = null
let _websocket    = null

let _conversations = new Map()
let _pageUnloading = false
let _reconnectTid  = 0

//-----------------------------------------------------------------------------
// Initialization
window.addEventListener('beforeunload', () => _pageUnloading = true)

//-----------------------------------------------------------------------------
// other methods
const initConversation = (msg) =>
{
  const { cid, wa_id, uid } = msg
  const conversation = {
    messages: [],
    details: { cid, wa_id, uid },
    phoneNumber: msg.phoneNumber,
    isFullyLoaded: false
  }
  _conversations.set(cid, conversation)
  _setRefresher?.()
  return conversation
}

const processMessageResponse = ({ messages, customers }) =>
{
  for (let msg of messages)
  {
    adjustMessageData(msg)
    const { cid, uid } = msg

    if (!_conversations.get(cid))
    {
      let conversation = initConversation(msg)

      if (uid) // existing customer
      {
        let customer = customers.find(c => c.id == uid)
        attachContactInfo(conversation, customer)
      }
    }
    let conversation = _conversations.get(cid)
    conversation.messages.push(msg)
  }

  _setRefresher?.()
}

const attachContactInfo = (conversation, customer) =>
{
  // skip if customer is not found
  if (!conversation) return
  if (!customer) return
        
  // setup partial details
  const {
    display_name,
    contacts,
    vehicles,
    bills
  } = customer

  conversation.details = {
    // clone
    ...conversation.details,
    // replace
    display_name,
    contacts,
    vehicles,
    bills
  }

  // update contact details
  let primaryContact = getPrimaryContact(contacts)
  if (primaryContact)
  {
    conversation.name = String(primaryContact.c_name).trim() || display_name
    conversation.phoneNumber = tryParsePhoneNumber(primaryContact.c_num)
  }
}


const loadCustomer = (uid) =>
{ 
  if (!uid) return
  return API.getCustomerDetail(uid).then(resp =>
  {
    if (resp.success)
    {
      const conversation = _conversations.get(uid)
      attachContactInfo(conversation, resp.msg)
      if (resp.msg.vehicles) {
        for (let vehicle of resp.msg.vehicles)
        {
          DataUtil.attachVehicleActiveService(vehicle)
        }
      }
      if (conversation) {
        conversation.isFullyLoaded = true
      }
      return conversation
    }
    else
    {
      PopMessage.show('無法讀取客戶資料。', '讀取失敗', 'danger')
    }
  })
}

//-----------------------------------------------------------------------------
// WebSocket event listners
const onWsOpen = (e) =>
{
  onConnected()
  onStatusChanged(_websocket.readyState)
  console.log('Connected to messaging server.')
}

const onWsClose = (e) =>
{
  onDisconnected()
  onStatusChanged(_websocket.readyState)

  if (_pageUnloading) {
    return false
  }

  PopMessage.show('已從伺服器連線中斷，正在嘗試重新連接。', '連線中斷', 'danger')
  _websocket.close()
  console.log('Connection closed')

  // try reconnecting
  if (!_reconnectTid)
  {
    _reconnectTid = setTimeout(() => {
      _reconnectTid = 0
      connect(true)
    }, 5000)
  }
}

const onWsError = (e) =>
{
  onStatusChanged(_websocket.readyState)
}

const onWsMessage = (e) =>
{
  let command = JSON.parse(e.data)
  PopMessage.show('收到新訊息！', '收到新訊息！', 'info')
  processCommand(command)
  onMessageReceived(command)
}

//-----------------------------------------------------------------------------
// Connection control
const connect = (isReconnect = false) =>
{
  if (isReconnect)
  {
    try
    {
      _websocket.onmessage = null
      _websocket.close()
    }
    catch
    {
      /* do nothing */
    }
  }

  if (null == _websocket || isReconnect)
  {
    const ptc  = window.location.protocol.replace('http', 'ws')
    _websocket = new WebSocket(`${ptc}//${G_apiBaseUrl}/im/connect`.replace(/(^\/|\/{2,})/g, '/'))
    _websocket.onopen    = onWsOpen
    _websocket.onclose   = onWsClose
    _websocket.onmessage = onWsMessage
    _websocket.onerror   = onWsError
  }
}

const disconnect = () =>
{
  _websocket?.close()
}

//-----------------------------------------------------------------------------
const register = (refresherSetter, subscriber) =>
{
  _subscriber = subscriber
  _setRefresher = () => {
    refresherSetter(new Date().valueOf())
  }
  _setRefresher()
}

const initialize = () =>
{
  ApiReady.then(() => {
    API.getLatestMessages().then(resp =>
    {
      if (resp.success)
      {
        processMessageResponse(resp.msg)
      } else {
        PopMessage.show('下載訊息時出現錯誤', '錯誤', 'danger')
      }
    })

    InstantMessageController.connect()
  })
}

const onConnected       = () => _subscriber?.onConnected?.()       && _setRefresher?.()
const onDisconnected    = () => _subscriber?.onDisconnected?.()    && _setRefresher?.()
const onStatusChanged   = () => _subscriber?.onStatusChanged?.()   && _setRefresher?.()
const onMessageReceived = () => _subscriber?.onMessageReceived?.() && _setRefresher?.()

const InstantMessageController = Object.freeze({
  connect,
  disconnect,
  register,
  initialize,
  initConversation,
  loadCustomer,
  get Conversations() { return new Map(_conversations) },
})

export default InstantMessageController

window.InstantMessageController = InstantMessageController
